
import React, { useEffect } from 'react';
import { Button } from 'antd';

import { t } from '../../languages';
import { recordPageGA } from '../../modules/ga';
import { PlusOutlined } from '@ant-design/icons';

const CreateClassButton = ({ lang, modalOption }) => {
  useEffect(() => {
  }, []);

  return (
    <section className="join-create-buttons">
      <Button type="primary" className="button-blue" onClick={e=>modalOption('createClass')}>
        <PlusOutlined />{t(lang, 'createClass')}
      </Button>

      {/* <Button type="default" className="button-white" onClick={e=>modalOption('joinClass')}>
        <PlusOutlined />{t(lang, 'joinClass')}
      </Button> */}
    </section>
  );
};

export default CreateClassButton;


